import { Box, Button, MenuItem, Select, useTheme } from '@mui/material'
import MedAgDataGrid from '../../components/MedAgDataGrid'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
import { ColDef } from 'ag-grid-community'
import { radiologyColor } from '../Radiology/Utils/RadiologyColors'
import { useState } from 'react'

const styles = () => ({
  centerHeader: {
    color: radiologyColor?.white,
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
  addBtn: {
    backgroundColor: '#4682b4',
    textTransform: 'capitalize',
    fontSize: '12px',
    padding: 'unset',
  },
})

const CreateTable = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  // eslint-disable-next-line
  const [rowData, setRowData] = useState([
    {
      id: 1,
      firstName: 'John Doe',
      UHID: 'UH12345',
      phone: '123-456-7890',
      admissionDate: '2025-01-15',
      type: 'General',
      status: 'Accepted',
    },
    {
      id: 2,
      firstName: 'Jane Smith',
      UHID: 'UH67890',
      phone: '987-654-3210',
      admissionDate: '2025-01-20',
      type: 'Emergency',
      status: 'Rejected',
    },
    {
      id: 3,
      firstName: 'Michael Brown',
      UHID: 'UH11223',
      phone: '456-789-0123',
      admissionDate: '2025-01-10',
      type: 'General',
      status: 'OnHold',
    },
    {
      id: 4,
      firstName: 'Emily Davis',
      UHID: 'UH44556',
      phone: '321-654-0987',
      admissionDate: '2025-01-18',
      type: 'Emergency',
      status: 'Accepted',
    },
    {
      id: 5,
      firstName: 'Chris Wilson',
      UHID: 'UH77889',
      phone: '654-321-4567',
      admissionDate: '2025-01-12',
      type: 'General',
      status: 'Rejected',
    },
  ])

  const renderName = (params: any) => {
    const firstName = params?.data?.firstName ?? ''
    const lastName = params?.data?.lastName ?? ''
    return firstName.concat(' ', lastName)
  }

  // eslint-disable-next-line
  const renderActions = (params: any) => {
    return (
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        width={'100%'}
      >
        <Button variant='contained' className={classes?.addBtn} size='small'>
          Add
        </Button>
      </Box>
    )
  }

  // eslint-disable-next-line
  const renderType = (params: any) => {
    return (
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        width={'100%'}
      >
        <Select size='small' variant='standard' fullWidth>
          <MenuItem value='general'>General</MenuItem>
          <MenuItem value='emergency'>Emergency</MenuItem>
        </Select>
      </Box>
    )
  }

  const columnDefs: ColDef[] = [
    {
      headerName: 'Sl No',
      field: 'id',
      width: 90,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Name',
      field: 'firstName',
      flex: 1,
      sortable: false,
      filter: false,
      cellRenderer: renderName,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      minWidth: 165,
    },
    {
      headerName: 'UHID',
      field: 'UHID',
      flex: 1,
      sortable: false,
      filter: false,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', display: 'flex', alignItems: 'center' },
      minWidth: 110,
    },
    {
      headerName: 'Phone',
      field: 'phone',
      flex: 1,
      sortable: false,
      filter: false,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      minWidth: 145,
    },
    {
      headerName: 'Type',
      field: 'type',
      flex: 1,
      sortable: false,
      filter: false,
      cellRenderer: renderType,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      width: 130,
    },

    {
      headerName: 'Actions',
      field: 'actions',
      width: 100,
      sortable: false,
      filter: false,
      cellRenderer: renderActions,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center', display: 'flex' },
    },
  ]

  return (
    <Box>
      <MedAgDataGrid
        tableHeading=''
        tableHeight={'500px'}
        rowData={rowData}
        columnDefs={columnDefs}
        pagination={false}
        headerHeight={30}
        searchFieldWidth={200}
        loading={false}
        exportIcon={false}
      />
    </Box>
  )
}

export default CreateTable
